import React, {useState} from 'react';
import { useAppSelector} from "../../creator-presets/DAL/store";
import LinkIcon from "../../../../ui/svg/common/link";
import FacebookIcon from "../../../../ui/svg/common/social-icons/facebook";
import TwitterIcon from "../../../../ui/svg/common/social-icons/twitter";
import {useWindowSize} from "../../../../domain/common";
import {copyPresetLink} from "../services/logic-helper";
import {FACEBOOK_SHARE_PATH, MAX_MOBILE_SIZE, MAX_TABLET_WIDTH, TWITTER_SHARE_PATH} from '../../common/constants';
import {ModeratorEntityTypeEnum} from "../../common/common-enum";
import {sendGAEvent} from "../../../../domain/marketing/gtm-provider";

const ShareIcons = () => {
    const [showLinkWasCopied,setShowLinkWasCopied] = useState(false);
    const mainPreset = useAppSelector((store) => store.mainPreset);

    const size = useWindowSize();

    const iconSize = (size.width !== undefined && size.width > MAX_MOBILE_SIZE) ? "15px":"21px";
    const linkIconSize = (size.width !== undefined && size.width > MAX_MOBILE_SIZE) ? "17px":"24px";
    const openPopUp = (link : string) => {
        window.open(link,'popup','width=600,height=600');
        return false;
    }
    return (
        <div className="flex items-center relative text-base md:text-lg md:text-base"
             style={size.width !== undefined && size.width > MAX_TABLET_WIDTH ? {width:"400px"}:{width:"auto"}}>
            <div className="flex-1 flex items-center justify-between">
                <div className="pr-6 hidden lg:block">
                    <a className="pr-6 text-black"
                       onClick={(evt) => {
                           sendGAEvent('Click', "Report an issue Chain: " + mainPreset.presetName);
                       }}
                       href={"/studioverse/report-an-issue/"+ModeratorEntityTypeEnum.Preset+"/"+mainPreset.presetGUID}>Report an issue</a>
                </div>
{/*
                <div className="hidden lg:block">|</div>
*/}
                <div className="pr-4 md:pr-4 lg:pr-3 cursor-pointer">Share</div>

            </div>

            <button className="px-4 cursor-pointer" aria-label="Share link"
                 onClick={() => {
                     sendGAEvent('Click', "copy link");
                     copyPresetLink(mainPreset.presetGUID, setShowLinkWasCopied);
                 }}>
                <LinkIcon width={linkIconSize} />
            </button>
            <button className="px-4 lg:px-3 cursor-pointer"
               onClick={() => {
                   sendGAEvent('Click', "Share Facebook");
                   openPopUp(FACEBOOK_SHARE_PATH + window.location.href);
               }}  >
                <FacebookIcon title={"share on Facebook"} width={iconSize} height={iconSize}/>
            </button>
            <button className="pl-4 lg:pl-3 cursor-pointer"
               onClick={() => {
                   sendGAEvent('Click', "Share Twitter");
                   openPopUp(TWITTER_SHARE_PATH + window.location.href);
               }}  >
                <TwitterIcon title={"share on Twitter"} width={iconSize} />
            </button>
            {showLinkWasCopied && <div className="ok-box text-sm absolute top-8" role="alert">The link has been copied to clipboard</div>}
        </div>
    )
};

export default ShareIcons;